import { useCallback, useRef } from 'react'
import { trackCarouselPaginated } from 'tripPlanner/utils/chatAnalytics'

/**
 * Tracks when a user scrolls a horizontal carousel (arrow click or swipe).
 * Returns an onScroll callback to pass to CardCarousel's onScroll prop.
 * Fires once per chatId to avoid duplicate events.
 */
export function useCarouselPaginationTracker(
  chatId: number | undefined,
) {
  const firedForChatRef = useRef<number | null>(null)

  const onScroll = useCallback(() => {
    if (chatId === undefined) return
    if (firedForChatRef.current === chatId) return

    firedForChatRef.current = chatId
    trackCarouselPaginated(chatId)
  }, [chatId])

  return { onCarouselScroll: onScroll }
}
